<template>
  <div class="news-center">
    <banner />
    <div class="news section">
      <div class="column">
        <h2>{{ detailsRes.title }}</h2>
        <div class="line"></div>
        <time>{{ $dayjs(detailsRes.createTime).format("YYYY-MM-DD") }}</time>
      </div>
      <div class="content" v-html="detailsRes.comRelatedContent"></div>
      <div class="relate-file" v-if="detailsRes.filedoc.length>0">
        <h2>相关文件</h2>
        <a
          :href="item.link"
          v-for="(item, index) in fileName"
          :key="index"
          download
          target="blank"
        >
          <div class="file-item justify-between items-center little_hand">
            <h3>{{ item.name }}</h3>
            <span class="items-center justify-end">
              <svg-icon icon-class="download"></svg-icon>
              下载
            </span>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import banner from "../common/banner.vue";
import { getRelatedDetails } from "@/assets/api/about.js";

import { mapState } from "vuex";

export default {
  name: "news",
  components: {
    banner,
  },
  data() {
    return {
      detailsRes: {},
      fileName: [],
    };
  },
  computed: {
    ...mapState(["isPc"]),
  },
  created() {
    getRelatedDetails(this.$route.params.id).then((res) => {
      this.detailsRes = res.data.data;
      this.detailsRes.filedoc = res.data.data.filedoc
        ? res.data.data.filedoc.split(",")
        : [];
      this.detailsRes.filedoc.map((item, index) => {
        let name=item.split("/")[item.split("/").length - 1]
        name=name.split("_")[0]
        this.fileName[index] = {
          name: name,
          link: !/^http/.test(item) ? this.$imgUrl + item : item,
        };
      });
    });
  },
  methods: {},
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.section {
  width: 800px;
  margin: auto;
  position: relative;
}
.column {
  padding-top: 60px;
  margin-bottom: 24px;

  h2 {
    font-size: 32px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #2c2c2e;
    line-height: 42px;
  }
  .line {
    width: 48px;
    height: 4px;
    background: #005bac;
    margin-top: 32px;
    margin-bottom: 16px;
  }
  time {
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #aeaeb2;
    line-height: 19px;
  }
}
.news-center {
  padding-bottom: 80px;
  .content {
    padding-top: 16px;
    padding-bottom: 40px;
    border-bottom: 1px solid #e5e5ea;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #2c2c2e;
    line-height: 24px;
  }
  .relate-file {
    margin-top: 24px;
    h2 {
      font-size: 16px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #2c2c2e;
      line-height: 21px;
      margin-bottom: 16px;
    }
    .file-item {
      width: 50%;
      background: #f8f8fa;
      padding: 20px;
      margin-top: 8px;
      h3 {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #2c2c2e;
        line-height: 19px;
      }
      span {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #005bac;
        line-height: 19px;
        white-space: nowrap;

        .svg-icon {
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .section {
    width: 100%;
    padding: 0 20px;
  }
  .column {
    padding-top: 40px;
    h2 {
      font-size: 24px;
      line-height: 31px;
    }
    .line {
      margin-top: 24px;
    }
  }
  .news-center {
    padding-bottom: 60px;
    .relate-file {
      .file-item {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/case-details/index.vue